import { useLocation } from "react-router-dom";
import "./AboutSec2.css";

// ⭐ IMPORT ALL DATA FROM NEW FILE
import {
  industriesData,
  defaultData,
  healthcareData,
  oilAndGasData,
  powerUtilitiesSectorData,
  wasteManagementData,
  miningAndMineralsData,
  assetManagementData,
  bankingData,
  financialAdvisoryData,
  financialServiceTaxData,
  fintechData,
  insuranceData,
  scienceReadyExpertiseData,
  privateEquityData,
  professionalServiceData,
  publicSectorData,
  realEstateConstructionData,
  mediaAndEntertainmentData,
  technologyData,
  telecommunicationData,
} from "../../../Data/AboutSec2Data";

// ⭐ IMPORT FRENCH TRANSLATIONS
import {
  industriesDataFR,
  defaultDataFR,
  healthcareDataFR,
  oilAndGasDataFR,
  powerUtilitiesSectorDataFR,
  wasteManagementDataFR,
  miningAndMineralsDataFR,
  assetManagementDataFR,
  bankingDataFR,
  financialAdvisoryDataFR,
  financialServiceTaxDataFR,
  fintechDataFR,
  insuranceDataFR,
  scienceReadyExpertiseDataFR,
  privateEquityDataFR,
  professionalServiceDataFR,
  publicSectorDataFR,
  realEstateConstructionDataFR,
  mediaAndEntertainmentDataFR,
  technologyDataFR,
  telecommunicationDataFR,
} from "../../../Data/French/AboutSec2DataFR";

export default function AboutSec2({ currentLanguage = "en" }) {
  const location = useLocation();

  const isIndustriesPage = location.pathname.startsWith("/industries");
  const isOilAndGas =
    location.pathname === "/industries/naturalresourcesandenergy/oilandgas";
  const isPowerUtilitiesSectorPage =
    location.pathname === "/industries/naturalresourcesandenergy/powerandutilities";
  const isScienceReadyPage = location.pathname === "/industries/lifescience";
  const isWasteManagementPage =
    location.pathname === "/industries/naturalresourcesandenergy/wastemanagement";
  const isMiningAndMineralsPage =
    location.pathname === "/industries/naturalresourcesandenergy/miningandminerals";
  const isAssetManagementPage =
    location.pathname === "/industries/financialservices/assetmanagement";
  const isBankingPage =
    location.pathname === "/industries/financialservices/banking";
  const isFinancialAdvisory =
    location.pathname === "/industries/financialservices/financialadvisoryservices";
  const isFinancialServiceTax =
    location.pathname === "/industries/financialservices/financialservicetax";
  const isFintechPage =
    location.pathname === "/industries/financialservices/fintech";
  const isInsurancePage =
    location.pathname === "/industries/financialservices/insurance";
  const isHealthcarePage = location.pathname === "/industries/healthcare";
  const isPrivateEquityPage = location.pathname === "/industries/privateequity";
  const isProfessionalServicePage =
    location.pathname === "/industries/professionalservice";
  const isPublicSectorPage = location.pathname === "/industries/publicsector";
  const isRealEstateConstructionPage =
    location.pathname === "/industries/realestateconstruction";
  const isMediaAndEntertainmentPage =
    location.pathname ===
    "/industries/technologymediaentertainmenttelecommunications/mediaandentertainment";
  const isTechnologyPage =
    location.pathname ===
    "/industries/technologymediaentertainmenttelecommunications/technology";
  const isTelecommunicationPage =
    location.pathname ===
    "/industries/technologymediaentertainmenttelecommunications/telecommunication";

  // SELECT DATA BASED ON LANGUAGE
  const isFrench = currentLanguage === "fr";

  const data = isOilAndGas
    ? isFrench ? oilAndGasDataFR : oilAndGasData
    : isPowerUtilitiesSectorPage
    ? isFrench ? powerUtilitiesSectorDataFR : powerUtilitiesSectorData
    : isWasteManagementPage
    ? isFrench ? wasteManagementDataFR : wasteManagementData
    : isMiningAndMineralsPage
    ? isFrench ? miningAndMineralsDataFR : miningAndMineralsData
    : isAssetManagementPage
    ? isFrench ? assetManagementDataFR : assetManagementData
    : isBankingPage
    ? isFrench ? bankingDataFR : bankingData
    : isFinancialAdvisory
    ? isFrench ? financialAdvisoryDataFR : financialAdvisoryData
    : isFinancialServiceTax
    ? isFrench ? financialServiceTaxDataFR : financialServiceTaxData
    : isFintechPage
    ? isFrench ? fintechDataFR : fintechData
    : isInsurancePage
    ? isFrench ? insuranceDataFR : insuranceData
    : isHealthcarePage
    ? isFrench ? healthcareDataFR : healthcareData
    : isScienceReadyPage
    ? isFrench ? scienceReadyExpertiseDataFR : scienceReadyExpertiseData
    : isPrivateEquityPage
    ? isFrench ? privateEquityDataFR : privateEquityData
    : isProfessionalServicePage
    ? isFrench ? professionalServiceDataFR : professionalServiceData
    : isPublicSectorPage
    ? isFrench ? publicSectorDataFR : publicSectorData
    : isRealEstateConstructionPage
    ? isFrench ? realEstateConstructionDataFR : realEstateConstructionData
    : isMediaAndEntertainmentPage
    ? isFrench ? mediaAndEntertainmentDataFR : mediaAndEntertainmentData
    : isTechnologyPage
    ? isFrench ? technologyDataFR : technologyData
    : isTelecommunicationPage
    ? isFrench ? telecommunicationDataFR : telecommunicationData
    : isIndustriesPage
    ? isFrench ? industriesDataFR : industriesData
    : isFrench ? defaultDataFR : defaultData;

  // HEADING TRANSLATIONS
  const headings = {
    en: {
      oilGas: {
        title: "OIL & GAS EXPERTISE",
        subtitle: "Strategic financial capabilities that solve complexity, unlock efficiency, and strengthen performance.",
      },
      scienceReady: {
        title: "SCIENCE-READY EXPERTISE",
        subtitle: "Practical, evidence-led support that strengthens decisions across research, development, and commercialization.",
      },
      powerUtilities: {
        title: "POWER & UTILITIES",
        subtitle: "Optimizing generation, transmission, and compliance across modern utility networks.",
      },
      wasteManagement: {
        title: "WASTE INTELLIGENCE",
        subtitle: "Smarter systems, cleaner outcomes. Turning waste into value.",
      },
      miningMinerals: {
        title: "MINERAL STRATEGY",
        subtitle: "Safer, smarter mining decisions your business way!",
      },
      assetManagement: {
        title: "PATH TO ASSET PERFORMANCE",
        subtitle: "We help asset managers strengthen decision-making, improve returns, and adapt confidently to shifting market realities.",
      },
      banking: {
        title: "WAYS TO STRENGTHEN BANKING",
        subtitle: "Practical strategies designed to help banks grow safely, efficiently, and sustainably.",
      },
      financialAdvisory: {
        title: "ADVISORY BUILT FOR REAL DECISIONS",
        subtitle: "Helping businesses strengthen decisions, reduce risk, and unlock long-term financial stability.",
      },
      financialServiceTax: {
        title: "SMARTER WAY TO MANAGE TAX",
        subtitle: "Designed to make tax planning clear, compliant, and strategically valuable.",
      },
      fintech: {
        title: "BUILT FOR DIGITAL FINANCE",
        subtitle: "A strategy framework designed for smarter, scalable, compliant FinTech growth.",
      },
      insurance: {
        title: "PATH TO INSURANCE PERFORMANCE",
        subtitle: "Balanced strategies that link financial strength with customer-centric innovation.",
      },
      healthcare: {
        title: "OUR APPROACH TO BETTER CARE",
        subtitle: "Designed to address financial realities while improving system efficiency & care delivery.",
      },
      privateEquity: {
        title: "PATH TO PORTFOLIO VALUE",
        subtitle: "Strategies that strengthen decisions across sourcing and portfolio performance.",
      },
      professionalService: {
        title: "OUR PROFESSIONAL SERVICES STRATEGY",
        subtitle: "Built to improve utilization, strengthen delivery quality, and bring financial clarity to every engagement.",
      },
      publicSector: {
        title: "OUR PUBLIC SECTOR STRATEGY",
        subtitle: "Focused on improving service delivery and modernizing government operations.",
      },
      realEstateConstruction: {
        title: "HOW WE STRENGTHEN PROJECTS",
        subtitle: "We focus on improving project visibility and strengthening financial control.",
      },
      mediaEntertainment: {
        title: "OUR MEDIA APPROACH",
        subtitle: "Designed to help media companies with operational discipline and evolving digital demands.",
      },
      technology: {
        title: "OUR TECHNOLOGY STRATEGY",
        subtitle: "Helping tech companies balance innovation with execution.",
      },
      telecommunication: {
        title: "OUR TELECOM STRATEGY",
        subtitle: "Designed to balance network investment, operational efficiency, and customer experience.",
      },
      industries: {
        title: "OUR SECTOR EXPERTISE",
        subtitle: "Comprehensive asset management solutions tailored to maximize value and minimize risk.",
      },
      default: {
        label: "OUR VISION",
        title: "BUILDING FINANCIAL CLARITY FOR THE WORLD AHEAD",
      },
    },
    fr: {
      oilGas: {
        title: "EXPERTISE PÉTROLE ET GAZ",
        subtitle: "Capacités financières stratégiques qui résolvent la complexité, libèrent l'efficacité et renforcent la performance.",
      },
      scienceReady: {
        title: "EXPERTISE PRÊTE POUR LA SCIENCE",
        subtitle: "Soutien pratique et fondé sur des preuves qui renforce les décisions en matière de recherche, développement et commercialisation.",
      },
      powerUtilities: {
        title: "ÉNERGIE ET SERVICES PUBLICS",
        subtitle: "Optimisation de la production, du transport et de la conformité dans les réseaux de services publics modernes.",
      },
      wasteManagement: {
        title: "INTELLIGENCE DES DÉCHETS",
        subtitle: "Des systèmes plus intelligents, des résultats plus propres. Transformer les déchets en valeur.",
      },
      miningMinerals: {
        title: "STRATÉGIE MINÉRALE",
        subtitle: "Des décisions minières plus sûres et plus intelligentes à votre façon!",
      },
      assetManagement: {
        title: "CHEMIN VERS LA PERFORMANCE DES ACTIFS",
        subtitle: "Nous aidons les gestionnaires d'actifs à renforcer la prise de décision, améliorer les rendements et s'adapter avec confiance aux réalités changeantes du marché.",
      },
      banking: {
        title: "MOYENS DE RENFORCER LA BANQUE",
        subtitle: "Stratégies pratiques conçues pour aider les banques à croître en toute sécurité, efficacement et durablement.",
      },
      financialAdvisory: {
        title: "CONSEIL POUR DE VRAIES DÉCISIONS",
        subtitle: "Aider les entreprises à renforcer leurs décisions, réduire les risques et débloquer la stabilité financière à long terme.",
      },
      financialServiceTax: {
        title: "MANIÈRE PLUS INTELLIGENTE DE GÉRER LA FISCALITÉ",
        subtitle: "Conçu pour rendre la planification fiscale claire, conforme et stratégiquement précieuse.",
      },
      fintech: {
        title: "CONSTRUIT POUR LA FINANCE NUMÉRIQUE",
        subtitle: "Un cadre stratégique conçu pour une croissance FinTech plus intelligente, évolutive et conforme.",
      },
      insurance: {
        title: "CHEMIN VERS LA PERFORMANCE ASSURANTIELLE",
        subtitle: "Stratégies équilibrées qui relient la solidité financière à l'innovation centrée sur le client.",
      },
      healthcare: {
        title: "NOTRE APPROCHE POUR DE MEILLEURS SOINS",
        subtitle: "Conçu pour répondre aux réalités financières tout en améliorant l'efficacité du système et la prestation de soins.",
      },
      privateEquity: {
        title: "CHEMIN VERS LA VALEUR DU PORTEFEUILLE",
        subtitle: "Stratégies qui renforcent les décisions en matière d'approvisionnement et de performance du portefeuille.",
      },
      professionalService: {
        title: "NOTRE STRATÉGIE DE SERVICES PROFESSIONNELS",
        subtitle: "Conçu pour améliorer l'utilisation, renforcer la qualité de prestation et apporter une clarté financière à chaque engagement.",
      },
      publicSector: {
        title: "NOTRE STRATÉGIE DU SECTEUR PUBLIC",
        subtitle: "Axé sur l'amélioration de la prestation de services et la modernisation des opérations gouvernementales.",
      },
      realEstateConstruction: {
        title: "COMMENT NOUS RENFORÇONS LES PROJETS",
        subtitle: "Nous nous concentrons sur l'amélioration de la visibilité des projets et le renforcement du contrôle financier.",
      },
      mediaEntertainment: {
        title: "NOTRE APPROCHE MÉDIATIQUE",
        subtitle: "Conçu pour aider les entreprises médiatiques avec discipline opérationnelle et demandes numériques en évolution.",
      },
      technology: {
        title: "NOTRE STRATÉGIE TECHNOLOGIQUE",
        subtitle: "Aider les entreprises technologiques à équilibrer innovation et exécution.",
      },
      telecommunication: {
        title: "NOTRE STRATÉGIE TÉLÉCOM",
        subtitle: "Conçu pour équilibrer l'investissement réseau, l'efficacité opérationnelle et l'expérience client.",
      },
      industries: {
        title: "NOTRE EXPERTISE SECTEUR",
        subtitle: "Solutions complètes de gestion d'actifs adaptées pour maximiser la valeur et minimiser le risque.",
      },
      default: {
        label: "NOTRE VISION",
        title: "CONSTRUIRE LA CLARTÉ FINANCIÈRE POUR LE MONDE À VENIR",
      },
    },
  };

  const currentHeadings = isFrench ? headings.fr : headings.en;

  // HEADING LOGIC
  const renderHeading = () => {
    if (isOilAndGas) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.oilGas.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.oilGas.subtitle}
          </h6>
        </>
      );
    }

    if (isScienceReadyPage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.scienceReady.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.scienceReady.subtitle}
          </h6>
        </>
      );
    }

    if (isPowerUtilitiesSectorPage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.powerUtilities.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.powerUtilities.subtitle}
          </h6>
        </>
      );
    }

    if (isWasteManagementPage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.wasteManagement.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.wasteManagement.subtitle}
          </h6>
        </>
      );
    }

    if (isMiningAndMineralsPage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.miningMinerals.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.miningMinerals.subtitle}
          </h6>
        </>
      );
    }

    if (isAssetManagementPage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.assetManagement.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.assetManagement.subtitle}
          </h6>
        </>
      );
    }

    if (isBankingPage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.banking.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.banking.subtitle}
          </h6>
        </>
      );
    }

    if (isFinancialAdvisory) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.financialAdvisory.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.financialAdvisory.subtitle}
          </h6>
        </>
      );
    }

    if (isFinancialServiceTax) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.financialServiceTax.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.financialServiceTax.subtitle}
          </h6>
        </>
      );
    }

    if (isFintechPage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.fintech.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.fintech.subtitle}
          </h6>
        </>
      );
    }

    if (isInsurancePage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.insurance.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.insurance.subtitle}
          </h6>
        </>
      );
    }

    if (isHealthcarePage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.healthcare.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.healthcare.subtitle}
          </h6>
        </>
      );
    }

    if (isPrivateEquityPage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.privateEquity.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.privateEquity.subtitle}
          </h6>
        </>
      );
    }

    if (isProfessionalServicePage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.professionalService.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.professionalService.subtitle}
          </h6>
        </>
      );
    }

    if (isPublicSectorPage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.publicSector.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.publicSector.subtitle}
          </h6>
        </>
      );
    }

    if (isRealEstateConstructionPage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.realEstateConstruction.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.realEstateConstruction.subtitle}
          </h6>
        </>
      );
    }

    if (isMediaAndEntertainmentPage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.mediaEntertainment.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.mediaEntertainment.subtitle}
          </h6>
        </>
      );
    }

    if (isTechnologyPage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.technology.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.technology.subtitle}
          </h6>
        </>
      );
    }

    if (isTelecommunicationPage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.telecommunication.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.telecommunication.subtitle}
          </h6>
        </>
      );
    }

    if (isIndustriesPage) {
      return (
        <>
          <h2 className="service-title">{currentHeadings.industries.title}</h2>
          <h6 className="industries-subtitle mt-2">
            {currentHeadings.industries.subtitle}
          </h6>
        </>
      );
    }

    return (
      <>
        <div className="d-flex align-items-center justify-content-center mb-2">
          <div className="services-line me-3"></div>
          <h6 className="service-subtitle mb-0">{currentHeadings.default.label}</h6>
        </div>
        <h2 className="service-title">{currentHeadings.default.title}</h2>
      </>
    );
  };

  return (
    <div className="aboutsec2-main-div section">
      <div className="text-center mb-5">{renderHeading()}</div>

      <div className="row aboutsec2-cards-wrapper">
        {data.map((item, index) => (
          <div
            className={isIndustriesPage ? "col-md-3" : "col-md-4"}
            key={index}
          >
            <div
              className={
                isIndustriesPage ? "industries-card-box" : "aboutsec2-card-box"
              }
            >
              <div className="aboutsec2-icon">
                <img src={item.icon} alt="icon" />
              </div>

              <h5
                className={
                  isIndustriesPage
                    ? "industries-card-title"
                    : "aboutsec2-card-title"
                }
              >
                {item.title}
              </h5>

              <p
                className={
                  isIndustriesPage
                    ? "industries-card-text"
                    : "aboutsec2-card-text"
                }
              >
                {item.text}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}